import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaInput } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { useToaster } from "utils";

export interface SmsSettingsFormProps {
  defaultSender: string;
}

export const SmsSettingsForm = ({ defaultSender }: SmsSettingsFormProps) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      apiToken: "",
      defaultSender,
    },
  });

  const onSubmit = async (values: SmsSettingsValues) => {
    try {
      // A blank sender is never stored: undefined means "leave unchanged".
      await settingsApi.saveSms({
        apiToken: values.apiToken || undefined,
        defaultSender: values.defaultSender?.trim() || undefined,
      });
      await invalidateSettings();
      showSuccess("Zapisano ustawienia SMS API");
    } catch (error) {
      showError("Błąd podczas zapisywania ustawień SMS API");
    }
  };

  const {
    handleSubmit,
    formState: { isDirty, errors },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
        <PaziaInput
          label="Token JWT SMS API"
          name="apiToken"
          type="password"
          placeholder="Pozostaw puste, aby nie zmieniać"
        />
        <PaziaInput
          label="Domyślny nadawca SMS"
          name="defaultSender"
          tooltip="Nadawca wybierany domyślnie przy tworzeniu SMS. Musi być zarejestrowany na koncie SMS API."
        />
        <div>
          <PaziaButton
            type="success"
            disabled={!isDirty}
            title="Zapisz"
            className={Object.keys(errors).length ? "mb-[26px]" : ""}
          />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    apiToken: yup.string().optional(),
    defaultSender: yup.string().optional(),
  })
  .required();

export type SmsSettingsValues = yup.InferType<typeof schema>;
